import React, { useState, useEffect, useCallback, useContext } from "react";
import "./FirstVendorDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Tab, Nav, Form } from "react-bootstrap";
import Common_Button from "../../../Common-Component/Common_Button/Common_Button";
import { getProductVariant } from "../../../../utils/apis/Product/Product";
import {
  faCartShopping,
  faShareNodes,
  faStar,
  faHeart as solidHeart,
} from "@fortawesome/free-solid-svg-icons";
import { getCartCheck } from "../../../../utils/apis/addToCart/addToCart";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Context } from "../../../../utils/context";

import {
  AddToCart,
  CartQuantity,
} from "../../../../utils/apis/addToCart/addToCart";
import Blue_Btn from "../../../Common-Component/common_btn/blue_btn/Blue_Btn";
import Dark_Blue_Btn from "../../../Common-Component/common_btn/dark_blue_btn/Dark_Blue_Btn";
import Common_Goto_Cart_Card from "../../../Common-Component/common_goto_cart_card/Common_Goto_Cart_Card";
import { encodeId } from "../../../../utils/common";
import Add_on_zoom_modal from "./add_on_zoom_modal/Add_on_zoom_modal";
const FirstVendorDetails = ({
  product,
  cartStatus,
  cartData,
  getProduct,
  setCartStatus,
  // setSelected,
  setSelectedVariant,
  selectedVariant,
  setCartData,
  product_id,
}) => {
  const { variant, setVariant, triggerCartUpdate, fetchCart, userdata } =
    useContext(Context);
  const [modalShow, setModalShow] = useState(false);
  const [clickedAddonIndex, setClickedAddonIndex] = useState(0);
  // const [selectedVariant, setSelectedVariant] = useState();
  const [selectedAddon, setSelectedAddon] = useState([]);
  const { getData, IMG_URL } = useContext(Context);
  const handleCheck = (item) => {
    setSelectedAddon((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item],
    );
  };

  const navigate = useNavigate();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [showModal, setShowModal] = useState(false);

  const addCart = async (data) => {
    const stock = Number(selectedVariant?.unit);

    if (stock <= 0) {
      alert("Out of stock");
      return;
    }

    //  If already in cart and qty >= stock
    if (cartStatus && cartData?.quantity >= stock) {
      alert(`Only ${stock} quantity available in stock.`);
      return;
    }

    // Add to cart API
    const res = await AddToCart(data);
    const updatedCart = await fetchCart();

    if (res) {
      setShowModal(true);
    }

    if (updatedCart?.success) {
      const cartItem = updatedCart?.data?.find(
        (item) =>
          item.product_id === data.product_id &&
          item.variant_id === data.variant_id,
      );

      if (cartItem) {
        setCartStatus(true);
        setCartData(cartItem);
      } else {
        setCartStatus(false);
        setCartData(null);
      }
    }

    triggerCartUpdate();
  };

  const handleVariantChange = async (variant) => {
    setSelectedVariant(variant);
    // setSelected(variant);
    setVariant(variant);
  };

  useEffect(() => {
    triggerCartUpdate();
  }, [cartStatus]);

  const handleBuyNow = async () => {
    try {
      await addCart({
        product_id: product?.id,
        variant_id: selectedVariant?.id,
        selectedAddon: selectedAddon,
      });
      navigate("/product-cart"); // Navigate after adding to cart
    } catch (error) {
      console.error("Error in handleBuyNow:", error);
    }
  };

  const [selectedQtyIndex, setSelectedQtyIndex] = useState(0);

  const getDiscount = (mrp, s_price) => {
    if (!mrp || !s_price) return 0;
    return Math.round(((mrp - s_price) / mrp) * 100);
  };

  useEffect(() => {
    if (!selectedVariant && product?.product_variants?.length > 0) {
      setSelectedVariant(product.product_variants[0]);
    }
  }, [product, selectedVariant]);

  const productUrl = `${window.location.origin}/vendor-page/${encodeId(
    product?.id,
  )}?user_id=${userdata?.id}`;

  const productName = product?.name;

  const handleShare = () => {
    const url = productUrl || window.location.href;
    const title = productName || document.title;

    if (navigator.share) {
      // Native share (mobile + some desktop browsers)
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      // Fallback: Open social share links (example: WhatsApp)
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`,
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <section className="first-vendor-details">
      <div className="title-details mt-md-4 mt-2">
        <div className="top_content_holder">
          <div className="left_side">
            <h2>{product?.name}</h2>

            <div className="price_div">
              <p className="mrp-class">₹{selectedVariant?.s_price}</p>
              <p className="return-mrp"> ₹{selectedVariant?.mrp}</p>
            </div>

            <p className="in-stock">
              <span
                style={{
                  color: selectedVariant?.unit <= 0 ? "red" : "green",
                  fontWeight: "600",
                }}
              >
                {selectedVariant?.unit <= 0 ? "Out Of Stock" : "In Stock"}
              </span>
            </p>
          </div>

          <div className="right_side">
            <div className="share_icon_holder">
              <FontAwesomeIcon
                icon={faShareNodes}
                className="share_icon"
                onClick={handleShare}
              />
            </div>

            <div className="reviews_div">
              <div className="star_div">
                <FontAwesomeIcon icon={faStar} className="star_icon" />
              </div>

              <div className="rating">
                <p>{product?.average_rating}</p>
              </div>

              <div className="reiview">
                <p>({product?.total_reviews} Reviews)</p>
              </div>
            </div>
          </div>
        </div>

        <div className="description_div">
          <p className="title_text">Description</p>
          <p className="text-holder-vendor-page descn_text">
            {htmlToReactParser.parse(product?.product_detail?.about)}
          </p>
        </div>
      </div>

      {/* <div className="variationdivvvvsize mb-3">
        <h6>Variants</h6>

        <Nav className="horizontal-nav">
          {variants.map((variant) => (
            <Nav.Item key={variant.id}>
              <Nav.Link
                eventKey={`v_name${variant.id}`}
                className={selectedVariant?.id === variant.id ? "active" : ""}
                onClick={() => handleVariantChange(variant)}
              >
                {variant?.v_name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div> */}

      <div className="row align-items-end">
        <div className="col-md-6">
          <div className="description_div my-4">
            <p className="sub_title_text">
              Select {product?.variant_category?.name}
            </p>

            <div className="quantity_box_holder">
              {product?.product_variants?.map((item, index) => {
                const discount = getDiscount(item?.mrp, item?.s_price);

                return (
                  <div
                    key={item.id}
                    className={`quantity_box ${
                      selectedQtyIndex === index ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedQtyIndex(index);
                      handleVariantChange(item);
                    }}
                  >
                    <div className="discount_badge">{discount}% Off</div>

                    <div className="weight_text">{item?.v_name}</div>

                    <div className="price_text">
                      ₹ {Number(item?.s_price).toFixed(2)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="button-effect">
            {/* {cartStatus ? (
          <div className="blue-bg d-flex me-3">
            <div className="circle-holder1">
              <button
                className="minus-btn me-md-5 me-0"
                type="button"
                onClick={() =>
                  getCartQuantity(cartData?.id, "minus", cartData?.quantity)
                }
              >
                <FontAwesomeIcon
                  className="minus-icon"
                  icon="fa-solid fa-minus"
                />
              </button>
            </div>
            <p className="number-text ">{cartData?.quantity}</p>
            <div className="circle-holder1">
              <button
                className="minus-btn"
                type="button"
                onClick={() =>
                  getCartQuantity(cartData?.id, "add", cartData?.quantity)
                }
              >
                <FontAwesomeIcon icon="plus" />
              </button>
            </div>
          </div>
        ) : ( */}

            <div className="btn_holder">
              <Blue_Btn
                btn_name="Add to Cart"
                leftIcon={faCartShopping}
                onClick={() =>
                  addCart({
                    product_id: product?.id,
                    variant_id: selectedVariant?.id,
                    selectedAddon: selectedAddon,
                  })
                }
              />
            </div>
            {/* )} */}

            {selectedVariant?.unit > 0 && (
              // <Common_Button
              //   className="add-to-cart-btn"
              //   text="Buy Now"
              //   icon="fa-solid fa-cart-shopping"
              //   onClick={handleBuyNow}
              // />

              <div className="btn_holder">
                <Blue_Btn
                  btn_name="Buy Now"
                  leftIcon={faCartShopping}
                  onClick={handleBuyNow}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {product?.product_addOns?.length > 0 && (
        <div className="addon_modal">
          <div className="modal-content">
            <div className="heading_holder">
              <h4 className="addon_title ">Select Add on's</h4>
            </div>

            <div>
              <div className="addon_list">
                {product?.product_addOns?.map((item, index) => (
                  <div className="addon_row" key={index}>
                    <div className="add_list_img_text_holder">
                      <div className="add_on_img_slider_holder">
                        <div>
                          <div
                            className="img_holder"
                            onClick={() => {
                              setClickedAddonIndex(item); // 👈 store clicked index
                              setModalShow(true);
                            }}
                          >
                            <img
                              src={
                                IMG_URL + item?.addon_images[0]?.image ||
                                "/assets/Image/near-me/phone.png"
                              }
                              alt="add on img"
                              className="add_on_img"
                            />
                          </div>
                        </div>
                      </div>

                      <p>{item.name}</p>
                    </div>
                    <div className="d-flex gap-3">
                      <div className="">
                        <p>{item.price}</p>
                      </div>
                      <Form.Check
                        className="addon_checkbox"
                        type="checkbox"
                        checked={selectedAddon.includes(item.id)}
                        onChange={() => handleCheck(item.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <hr />
      <div className="description_div my-4">
        <p className="title_text">Product Specifications</p>
        <div className="row justify-content-start">
          <div className="col-12">
            <div className="details_box_holder">
              <Row className="row_holder me-0 ms-0">
                <Col xl={4} xs={5}>
                  <p className="brod-title">
                    Category <span>:</span>
                  </p>
                </Col>
                <Col xl={8} xs={7}>
                  <p className="brod-subtitle">{product?.category?.name}</p>
                </Col>
              </Row>
              <Row className="row_holder me-0 ms-0">
                <Col xl={4} xs={5}>
                  <p className="brod-title">
                    Sub Category <span>:</span>
                  </p>
                </Col>
                <Col xl={8} xs={7}>
                  <p className="brod-subtitle">{product?.sub_category?.name}</p>
                </Col>
              </Row>
              <Row className="row_holder me-0 ms-0">
                <Col xl={4} xs={5}>
                  <p className="brod-title">
                    Child Category <span>:</span>
                  </p>
                </Col>
                <Col xl={8} xs={7}>
                  <p className="brod-subtitle">
                    {product?.child_sub_category?.name}
                  </p>
                </Col>
              </Row>

              <Row className="row_holder me-0 ms-0">
                <Col xl={4} xs={5}>
                  <p className="brod-title">
                    Brand <span>:</span>
                  </p>
                </Col>
                <Col xl={8} xs={7}>
                  <p className="brod-subtitle">
                    {product?.product_detail?.brand?.name}
                  </p>
                </Col>
              </Row>

              <Row className="row_holder me-0 ms-0">
                <Col xl={4} xs={5}>
                  <p className="brod-title">
                    Seller <span>:</span>
                  </p>
                </Col>
                <Col xl={8} xs={7}>
                  <p className="brod-subtitle">{product?.user?.first_name}</p>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="orange-bg-details ">
          <Row>
            <Col xl={4} xs={5}>
              <p className="brod-title-2">
                Local Mandai Customer Care Email <span>:</span>
              </p>
            </Col>
            <Col xl={8} xs={7}>
              <p className="brod-subtitle-2">{product?.user?.email}</p>
            </Col>
          </Row>
          <Row>
            <Col xl={4} xs={5}>
              <p className="brod-title-2">
                Local Mandai Customer Care Phone <span>:</span>{" "}
              </p>
            </Col>
            <Col xl={8} xs={7}>
              <p className="brod-subtitle-2">{product?.user?.contact_no}</p>
            </Col>
          </Row>
          <Row>
            <Col xl={4} xs={5}>
              <p className="brod-title-2">
                Country of Origin <span>:</span>
              </p>
            </Col>
            <Col xl={8} xs={7}>
              <p className="brod-subtitle-2">India</p>
            </Col>
          </Row>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="description_div">
            <p className="title_text">Benefits</p>
            <p className="text-holder-vendor-page descn_text">
              {htmlToReactParser.parse(product?.product_detail?.benifits)}
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="description_div">
            <p className="title_text">Storage and Uses</p>
            <p className="text-holder-vendor-page descn_text">
              {htmlToReactParser.parse(product?.product_detail?.storage)}
            </p>
          </div>
        </div>
      </div>
      <Common_Goto_Cart_Card
        selectedVariant={selectedVariant}
        product={product}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />

      <Add_on_zoom_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        addons={clickedAddonIndex}
        initialIndex={clickedAddonIndex?.id}
      />
    </section>
  );
};

export default FirstVendorDetails;
